import Select from "react-select"
import React, { Fragment } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Input,
  CardTitle,
  Label,
} from "reactstrap"
export const Filters = () => {
  return (
    <Fragment>
      <Card>
        <CardBody>
          <CardTitle className="mb-4"></CardTitle>

          <div className="row mb-4">
            <Col lg={4}>
              <Label htmlFor="horizontal-firstname-Input">From Date</Label>
              <Input
                type="date"
                className="form-control"
                id="horizontal-firstname-Input"
              />
            </Col>
            <Col lg={4}>
              <Label htmlFor="horizontal-firstname-Input">To Date</Label>
              <Input
                type="date"
                className="form-control"
                id="horizontal-firstname-Input"
              />
            </Col>
            <Col lg={4} className="d-flex flex-column justify-content-end">
              <Button type="submit" color="primary" className="w-md">
                Submit
              </Button>
            </Col>
          </div>
        </CardBody>
      </Card>
    </Fragment>
  )
}
